import 'normalize.css/normalize.css';
import 'rc-slider/assets/index.css';
import 'react-dates/lib/css/_datepicker.css';
import 'swiper/dist/css/swiper.min.css';
import '@/components/Common/styles/setup.scss';
import '@/static/photoswipe.css';

import { getRunMode } from '@/utils';
import { featureFlagsConfig } from '@/utils/feature-flag';
import { FeatureFlagProvider } from '@/utils/feature-flag/react';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { Hydrate, QueryClient, QueryClientProvider } from 'react-query';
//React Query Devtools는 process.env.NODE_ENV === 'development' 일때만 bundle 에 포함된다
import { ReactQueryDevtools } from 'react-query/devtools';

const SunnyApp: React.FC<AppProps> = ({ Component, pageProps }) => {
  const router = useRouter();

  useEffect(() => {
    router.beforePopState(() => false);
  });

  const [queryClient] = React.useState(() => new QueryClient());

  return (
    <FeatureFlagProvider featureFlagsConfig={featureFlagsConfig} featureFlagEnv={getRunMode()}>
      <QueryClientProvider client={queryClient}>
        <Hydrate state={pageProps.dehydratedState}>
          <Head>
            <meta
              name="viewport"
              content="initial-scale=1, maximum-scale=1, width=device-width, shrink-to-fit=no, user-scalable=no, viewport-fit=cover"
            />
          </Head>
          <Component {...pageProps} />
        </Hydrate>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </FeatureFlagProvider>
  );
};

export default SunnyApp;
